import { Services } from '@sigma-frontend-libs/commons'
import { PUBLIC_FIELDS_USER } from '@sigma-legacy-libs/essentials/lib/constants'

import { fillDependence, permissionPresets, proxy, sourceItems } from '@/utils'

import { tariffPriceIsValid, tariffRulesHaveValidPrices } from '@/components/services/tariffs/utils'

import render from './render'

export default {
  name: 'Form',

  mixins: [ proxy({ type: 'object' }), sourceItems(Services.tariffs) ],

  props: {
    isNew: Boolean
  },

  computed: {
    priceSource() {
      if (!this.proxy.source) {
        return undefined
      }

      const [ , source ] = this.proxy.source.split('.') || []

      return source
    },

    pricesValidation() {
      const rules = this.proxy.data && this.proxy.data.rules
      if (!tariffRulesHaveValidPrices(rules, this.priceSource)) {
        return false
      }

      if (this.proxy._defaultRule) {
        return tariffPriceIsValid(this.proxy._defaultRule.price, this.priceSource)
      }

      return true
    },

    sourceIsLegacySendingType() {
      if (this.proxy?.source) {
        const [ service ] = this.proxy.source.split('.')

        return service === Services.sendings
      }
    },

    validation() {
      if (!this.proxy.title) {
        return false
      }
      if (!this.proxy.source) {
        return false
      }
      if (!this.pricesValidation) {
        return false
      }

      return true
    }
  },

  watch: {
    validation() {
      this.$emit('validation', this.validation)
    }
  },

  async mounted() {
    await fillDependence.call(this, this.proxy, {
      service: Services.users,
      permissions: permissionPresets.resellerUp,
      pathToObject: 'Users',
      picks: PUBLIC_FIELDS_USER.concat([ 'usersTariffs' ]),
      outputPath: 'Users'
    })

    this.$emit('validation', this.validation)
  },

  render
}
